export default __webpack_public_path__ + "static/media/acoes.af6f5af8.svg";